import { ROUTER_PATHS, gridSizeMdLg6, gridSizeMdLg4, gridSizeMdLg2, gridSizeMdLg3, hasPermission, gridSizeMdLg8 } from "@/shared";
import {
    CustomTextAreaNoForm,
    CustomTextFieldNoForm,
    LoaderComponent, SampleCheckboxNoForm, SampleDatePickerNoForm, SampleTable, SingleFormBoxScene,
    SingleTableBoxScene, TabTexLabelCustomSpace, TabTextLabel
} from "@/shared/components/ui";
import { Accordion, AccordionDetails, AccordionSummary, Divider, Grid, Typography } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { ArrowBack, ExpandMore } from '@mui/icons-material';
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from 'yup';
import { OrdenTrabajoNoc, ActividadesFibra, EquipmentUsed } from "@/shared/interfaces/erp/noc/orden-trabajo-noc.interface";
import { useNavigate, useParams } from "react-router-dom";
import { MRT_ColumnDef } from "material-react-table";
import ViewActividadesModal from "../components/ViewActividadesFibraModal";
import { useFetchWorkOrderById, useGetFlotaByUser } from "../actions/noc-module.actions";
import ListaImagen from "../components/ListaImagen";
import AuditReviewModal from "../components/AuditReviewModal";
import { PermissionsEnum } from "@/auth/interfaces";

type SaveFormData = Omit<OrdenTrabajoNoc, 'workOrderId'>;

export default function VerOrdenTrabajoNoc() {

    const { id } = useParams();

    const navigate = useNavigate();
    const returnUrlOrdenTrabajoPage = ROUTER_PATHS.noc.ordenesDeTrabajoNocListaNav;
    const returnUrlOrdenTrabajoInformePage = ROUTER_PATHS.tecnico.ordenesNocNav;
    const username = JSON.parse(localStorage.getItem("auth") || "{}")?.state?.user?.username;

    const { data: flotaUserRes } = useGetFlotaByUser(username) as any;
    const codigoFlota = flotaUserRes?.data;

    const [openActividadesModal, setOpenActividadesModal] = useState(false);

    // hook para obtener orden de trabajo noc
    const {
        isLoading,
        data: workOrderRes,
        refetch
    } = useFetchWorkOrderById({
        workOrderId: id as string
    }, {
        enabled: !!id
    }) as any;


    const newOrdenTrabajoSchema = yup.object({
        fleetCode: yup.string().required('La flota es requerida'),
        workDate: yup.date().required('La fecha de trabajo es requerida'),
        orderName: yup.string().required('El nombre es requerido'),
    });

    const form = useForm<SaveFormData>({
        resolver: yupResolver(newOrdenTrabajoSchema as any),
        defaultValues: {
            fleetCode: '',
            fleetName: '',
            workDate: '',
            orderName: '',
            mobilizationValue: 0,
            activitiesOrder: [],
        },
    });

    useEffect(() => {
        // workOrderRes esta tipado como {} por el hook generico; en runtime
        // trae { data: OrdenTrabajoNoc }. Cast a any para acceder a .data.
        const wr = workOrderRes as any;
        if (wr?.data) {
            form.reset(wr.data);
        }
    }, [workOrderRes, form]);

    const {
        handleSubmit,
    } = form;

    const dataMapped: ActividadesFibra[] = (form.getValues().activitiesOrder);

    const columnsEquipamiento = useMemo<MRT_ColumnDef<EquipmentUsed>[]>(
        () => [
            {
                header: "PRODUCTO",
                accessorKey: "nameProductUsed",
                size: 200,
            },
            {
                header: "CANTIDAD",
                accessorKey: "amountProductUsed",
                size: 50,
            },
            {
                header: "SERIE",
                accessorKey: "seriesProductUsed",
                size: 50,
            },
            {
                header: "ESTADO PRODUCTO",
                accessorKey: "statusProductUsed",
                size: 50,
            },
        ],
        []
    );

    const [revisarAuditoria, setRevisarAuditoria] = useState(false);
    const onRevisarAuditoria = () => {
        setRevisarAuditoria(true);
    }


    // spinner hasta cargas las flotas
    if (isLoading) {
        return <LoaderComponent />
    }

    return (
        <>
            <SingleTableBoxScene
                title={`Ver Orden de Trabajo`}
                textRedirect={"Atras"}
                iconRedirect={<ArrowBack />}
                urlRedirect={codigoFlota?.data.length > 0 ? `${returnUrlOrdenTrabajoInformePage}` : `${returnUrlOrdenTrabajoPage}`}
                visibleReport={true}
            >

                <SingleFormBoxScene
                    titlePage={""}
                    onCancel={() => {
                        if (codigoFlota?.data.length > 0) {
                            navigate(returnUrlOrdenTrabajoInformePage);
                        } else {
                            navigate(returnUrlOrdenTrabajoPage);
                        }
                    }}
                    containerMaxWidth={"xl"}
                    py={6}
                    showActionBtns={hasPermission(PermissionsEnum.custom_auditoria_ordenes_noc) ? true : false}
                    onSave={
                        hasPermission(PermissionsEnum.custom_auditoria_ordenes_noc)
                            ? handleSubmit(onRevisarAuditoria)
                            : undefined
                    }
                    saveTextBtn={"Revisar Auditoria"}
                    disableSubmitBtn={codigoFlota?.data.length > 0 ? true : (form.getValues().orderStatus === 'FINALIZADO' ? true : false)}
                >

                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <TabTextLabel
                                text={"INFORMACIÓN GENERAL DE LA ORDEN"}
                                mt={0}
                                pb={2}
                                pl={0}
                                pt={2}
                            />
                        </Grid>

                        <CustomTextFieldNoForm
                            label="Estado de la Orden"
                            defaultValue={form.getValues().orderStatus || ''}
                            size={gridSizeMdLg6}
                            disabled={true}
                        />
                        <CustomTextFieldNoForm
                            label="Nombre de la Orden"
                            defaultValue={form.getValues().orderName || ''}
                            size={gridSizeMdLg6}
                            disabled={true}
                        />

                        <CustomTextFieldNoForm
                            label="Fecha de Trabajo"
                            defaultValue={form.getValues().workDate || ''}
                            size={gridSizeMdLg6}
                            disabled={true}
                        />
                        <CustomTextFieldNoForm
                            label="Flota Asignada"
                            defaultValue={form.getValues().fleetName || ''}
                            size={gridSizeMdLg6}
                            disabled={true}
                        />
                        <Grid item {...gridSizeMdLg6}>
                            <SampleCheckboxNoForm
                                label="Es Orden de Alcance ?"
                                defaultValue={!!form.getValues().isScope || false}
                                disabled={true}
                            />
                        </Grid>
                        <SampleDatePickerNoForm
                            label="Fecha de Trabajo Anterior"
                            defaultValue={form.getValues().previousWorkDate || ''}
                            size={gridSizeMdLg6}
                            disabled={true}
                        />

                        <CustomTextFieldNoForm
                            label="Operador Registra"
                            defaultValue={form.getValues().userRegister || ''}
                            size={gridSizeMdLg6}
                            disabled={true}
                        />
                        <CustomTextFieldNoForm
                            label="Valor Movilización"
                            defaultValue={form.getValues().mobilizationValue || ''}
                            size={gridSizeMdLg6}
                            disabled={true}
                        />

                    </Grid>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Divider sx={{ my: 2 }} />
                        </Grid>
                    </Grid>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <TabTexLabelCustomSpace
                                textContent={"LISTADO DE ACTIVIDADES"}
                            />
                        </Grid>

                        {dataMapped && dataMapped.map((item, index) => {
                            return (
                                <>
                                    <Grid container spacing={3} key={index}>
                                        <Grid item xs={12}>
                                            <Accordion defaultExpanded style={{ border: "1px #6366F1 solid" }}>
                                                <AccordionSummary
                                                    expandIcon={<ExpandMore />}
                                                    aria-controls="panel3-content"
                                                    id="panel3-header"
                                                    style={{ backgroundColor: item.activityStatus === "CANCELADO" ? "#ff00002b" : item.activityStatus === "REALIZADO" ? "#00ff0021" : "#7779ee", borderRadius: "8px" }}
                                                >
                                                    <Typography component="span">Actividad # <strong>{item.idActivitiesOrder}</strong> :: {item.activityName}</Typography>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <br></br>
                                                    <Grid container spacing={3}>
                                                        <CustomTextFieldNoForm
                                                            label="Estado de la Actividad"
                                                            defaultValue={item.activityStatus || ''}
                                                            size={gridSizeMdLg4}
                                                            disabled={true}
                                                        />
                                                        <CustomTextFieldNoForm
                                                            label="Hora Inicial"
                                                            defaultValue={item.startTime || ''}
                                                            size={gridSizeMdLg4}
                                                            disabled={true}
                                                        />
                                                        <CustomTextFieldNoForm
                                                            label="Hora Final"
                                                            defaultValue={item.endTime || ''}
                                                            size={gridSizeMdLg4}
                                                            disabled={true}
                                                        />

                                                        <CustomTextFieldNoForm
                                                            label="Tipo"
                                                            defaultValue={item.type || ''}
                                                            size={gridSizeMdLg4}
                                                            disabled={true}
                                                        />
                                                        <CustomTextFieldNoForm
                                                            label="Actividad"
                                                            defaultValue={item.incidents.activityType.nameActivityType || ''}
                                                            size={gridSizeMdLg4}
                                                            disabled={true}
                                                        />
                                                        <CustomTextFieldNoForm
                                                            label="Incidencia"
                                                            defaultValue={item.incidents.name || ''}
                                                            size={gridSizeMdLg4}
                                                            disabled={true}
                                                        />

                                                        <CustomTextFieldNoForm
                                                            label="Dirigido a"
                                                            defaultValue={item.forTheActivity || ''}
                                                            size={gridSizeMdLg4}
                                                            disabled={true}
                                                        />

                                                        {item.forTheActivity === "CLIENTE" ?
                                                            <>
                                                                <CustomTextFieldNoForm
                                                                    label="Cliente"
                                                                    defaultValue={item.clientName || ''}
                                                                    size={gridSizeMdLg8}
                                                                    disabled={true}
                                                                />
                                                            </>
                                                            :
                                                            <>
                                                                <CustomTextFieldNoForm
                                                                    label="Nodo"
                                                                    defaultValue={item.nodeName || ''}
                                                                    size={gridSizeMdLg8}
                                                                    disabled={true}
                                                                />
                                                            </>
                                                        }

                                                        <CustomTextFieldNoForm
                                                            label="Requiere Coordenadas"
                                                            defaultValue={item.incidents.requireCoordinates ? 'SI' : 'NO'}
                                                            size={gridSizeMdLg2}
                                                            disabled={true}
                                                        />
                                                        <CustomTextFieldNoForm
                                                            label="Coordenada Inicial"
                                                            defaultValue={item.initialCoordinate || ''}
                                                            size={gridSizeMdLg3}
                                                            disabled={true}
                                                        />
                                                        <CustomTextFieldNoForm
                                                            label="Coordenada Final"
                                                            defaultValue={item.finalCoordinate || ''}
                                                            size={gridSizeMdLg3}
                                                            disabled={true}
                                                        />
                                                        <CustomTextFieldNoForm
                                                            label="Sector"
                                                            defaultValue={item.sector || ''}
                                                            size={gridSizeMdLg4}
                                                            disabled={true}
                                                        />

                                                        <CustomTextFieldNoForm
                                                            label="Requiere Cajas"
                                                            defaultValue={item.isBoxInstallation ? 'SI' : 'NO'}
                                                            size={gridSizeMdLg2}
                                                            disabled={true}
                                                        />

                                                        <CustomTextFieldNoForm
                                                            label="Listado de Cajas"
                                                            defaultValue={
                                                                item.primarySecondaryBox
                                                                    ?.map((caja) => caja.name)
                                                                    .join(', ') ?? ''
                                                            }
                                                            size={gridSizeMdLg6}
                                                            disabled={true}
                                                        />

                                                        <CustomTextAreaNoForm
                                                            label="Observación de la actividad"
                                                            size={gridSizeMdLg6}
                                                            value={item.activityDetail}
                                                            disabled={true}
                                                        />
                                                        <CustomTextAreaNoForm
                                                            label="Informe de la actividad"
                                                            size={gridSizeMdLg6}
                                                            value={item.reportActivity}
                                                            disabled={true}
                                                        />

                                                    </Grid>

                                                    <Grid container spacing={3}>
                                                        <Grid item xs={12}>
                                                            <Divider sx={{ my: 2 }} />
                                                        </Grid>
                                                    </Grid>

                                                    <Grid container spacing={3}>
                                                        <Grid item xs={12}>
                                                            <TabTexLabelCustomSpace
                                                                textContent={"Equipamiento Utilizado"}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12}>
                                                            <SampleTable<EquipmentUsed>
                                                                columns={columnsEquipamiento}
                                                                data={item.equipmentUsed || []}
                                                            />
                                                        </Grid>
                                                    </Grid>

                                                    <Grid container spacing={3}>
                                                        <Grid item xs={12}>
                                                            {item.photosReports.length === 0 ? (
                                                                <Typography variant="body2" color="textSecondary">
                                                                    No hay fotografías para esta actividad.
                                                                </Typography>
                                                            ) : (
                                                                <ListaImagen itemData={item.photosReports.map((photo: any) => (
                                                                    {
                                                                        img: photo.urlPhotoReport,
                                                                        title: 'Actividad',
                                                                        author: item.activityName,
                                                                        id: photo.idPhotoReport,
                                                                        orderStatus: form.getValues().orderStatus
                                                                    }
                                                                ))} refetch={refetch} />
                                                            )}
                                                        </Grid>
                                                    </Grid>

                                                </AccordionDetails>
                                            </Accordion>
                                        </Grid>
                                    </Grid>

                                    <Grid container spacing={3}>
                                        <Grid item xs={12}>
                                            <Divider sx={{ my: 2 }} style={{ color: "black" }} />
                                        </Grid>
                                    </Grid>
                                </>
                            )
                        })}

                        <Grid item xs={12}>
                            <TabTextLabel
                                text={"INFORMACIÓN PRIMERA JORNADA LABORAL"}
                                mt={0}
                                pb={2}
                                pl={0}
                                pt={2}
                            />
                        </Grid>

                        <CustomTextFieldNoForm
                            label="Inicio de la Jornada"
                            defaultValue={form.getValues().startTimeOrder || ''}
                            size={gridSizeMdLg3}
                            disabled={true}
                        />
                        <CustomTextFieldNoForm
                            label="Finalización de la Jornada"
                            defaultValue={form.getValues().endTimeOrder || ''}
                            size={gridSizeMdLg3}
                            disabled={true}
                        />
                        <CustomTextFieldNoForm
                            label="Tiempo Almuerzo"
                            defaultValue={form.getValues().lunchTime || ''}
                            size={gridSizeMdLg3}
                            disabled={true}
                        />
                        <CustomTextFieldNoForm
                            label="Horas Extras"
                            defaultValue={form.getValues().overtime || ''}
                            size={gridSizeMdLg3}
                            disabled={true}
                        />


                        <Grid item xs={12}>
                            <TabTextLabel
                                text={"INFORMACIÓN SEGUNDA JORNADA LABORAL (OPCIONAL)"}
                                mt={0}
                                pb={2}
                                pl={0}
                                pt={2}
                            />
                        </Grid>

                        <CustomTextFieldNoForm
                            label="Inicio de la Jornada"
                            defaultValue={form.getValues().startTimeOrder2 || ''}
                            size={gridSizeMdLg3}
                            disabled={true}
                        />
                        <CustomTextFieldNoForm
                            label="Finalización de la Jornada"
                            defaultValue={form.getValues().endTimeOrder2 || ''}
                            size={gridSizeMdLg3}
                            disabled={true}
                        />
                        <CustomTextFieldNoForm
                            label="Tiempo Almuerzo"
                            defaultValue={form.getValues().lunchTime2 || ''}
                            size={gridSizeMdLg3}
                            disabled={true}
                        />
                        <CustomTextFieldNoForm
                            label="Horas Extras"
                            defaultValue={form.getValues().overtime2 || ''}
                            size={gridSizeMdLg3}
                            disabled={true}
                        />

                    </Grid>

                </SingleFormBoxScene>

            </SingleTableBoxScene >

            {/* ----------- Modals ----------- */}
            {
                openActividadesModal && (
                    <ViewActividadesModal
                        open={openActividadesModal}
                        setOpen={setOpenActividadesModal}
                        form={form}
                    />
                )
            }

            {revisarAuditoria && (
                <AuditReviewModal
                    open={revisarAuditoria}
                    setOpen={setRevisarAuditoria}
                    form={form}
                    refetch={refetch}
                />
            )}

        </>
    );
}